import React, { type ComponentProps } from 'react'

import type { SemanticColorToken } from '../themes'
import { type ThemeColorToken } from '../themes'
import { SemanticColorOverride } from './SemanticColorOverride'
import { resolveToThemeColorToken, useTheme } from './ThemeProvider'

type Props = {
  color: SemanticColorToken | ThemeColorToken | null
  children: ComponentProps<typeof SemanticColorOverride>['children']
}

/**
 * Overrides the primary color of the nodes inside of its React tree. Accepts either a
 * color (for example, `Hydro`) or a color group token (for example, `semantic.error`).
 */
export function PrimaryColorOverride({ children, color }: Props) {
  const prevTheme = useTheme()

  if (!color) {
    return <>{children({ __experimentalCssString: '', rootClassName: '' })}</>
  }

  const resolvedColor = resolveToThemeColorToken(color, prevTheme)
  return (
    <SemanticColorOverride primary={resolvedColor}>
      {children}
    </SemanticColorOverride>
  )
}
